module.exports = __webpack_public_path__ + "media/theme/icon__status--paid-73f93822.svg";